/**
 * Assigns each footer link's wrapper an explicit grid-row within its own
 * column (Quick Links / Legal), based on the nav-link--quick_links/
 * nav-link--legal class on the <a> inside it - see sections/footer.liquid
 * and blocks/footer_link.liquid for why that class exists instead of
 * filtering block.type/block.settings directly (theme blocks are opaque
 * outside content_for in the parent section).
 *
 * Sets grid-row on .shopify-block (the wrapper content_for 'blocks' adds
 * around every rendered block, for the theme editor's click-to-select) -
 * NOT on .nav-link itself, since grid item properties only take effect
 * on an element that's a direct child of the grid container, which the
 * wrapper is and the nested <a> isn't. The matching grid-column (see the
 * CSS) is set on that same wrapper via a :has() rule instead of here, so
 * columns still group correctly even without JS - only the vertical
 * stacking order within each column needs this script.
 */
(function () {
  var counters = { quick_links: 2, legal: 2 };

  document.querySelectorAll('.footer__nav .nav-link').forEach(function (link) {
    var wrapper = link.closest('.shopify-block');
    if (!wrapper) return;

    var column = link.classList.contains('nav-link--legal') ? 'legal' : 'quick_links';
    wrapper.style.gridRow = counters[column];
    counters[column] += 1;
  });
})();
